export default __webpack_public_path__ + "static/media/Pahalgam3.d7d94f49.jpg";